<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, nextTick, getCurrentInstance } from "vue";
import { Globals } from "@/Globals";
import { isPhone } from "@/DeviceInfoPlugin";
import {
  checkBegriff,
  globalsBezeichnung,
  globalsModellFarbe,
  begriffBezeichnung,
} from "@/local";
import Constants from "@/Constants";
import {
  DialogParameter,
  showDialog,
  singleClick,
  useClickLock,
} from "@/UIHelper";
import {
  getKennungValueDisplay,
  getKennungValue,
  getKZValue,
} from "@/DataHelper";
import CalcButton from "@/components/CalcButton.vue";
import VButtonCarousel from "@/components/common/VButtonCarousel.vue";
import { mountedBase, BaseSetup } from "@/DataLoaderStatic";
import { getSiteData } from "@/NavigationHelper";

const emit = defineEmits(["reloadReise", "back", "goBack"]);
let carousel1: carouselItems[] = [];
let carousel2: carouselItems[] = [];
let carousel3: carouselItems[] = [];
const currentSlide = ref<number>(0);
const currentSlide2 = ref<number>(0);
const currentSlide3 = ref<number>(0);
let response: string = "";
let letzteBuchung: string = "---";
let letzteBuchungUm: string = "---";
const buchungsText = ref<string>("");
let memo = ref<string>("");
let abwUhrzeit = ref<Date | null>(null);
let uhrzeit: string | null = "";
let format: string = "HH:mm";
let begriff: any = null;
let absolute: boolean = true;
let dateString = ref<string>("heute");
let timeDate: Date = new Date();
let showCarousel = ref<boolean>(true);
let showZeitzone = ref<boolean>(false);
let zeitzones = ref<ListItems[]>([]);
let offset!: number;
let changedoffset!: number;
let offsetChange: boolean = false;
let offsetString!: string;
let aktZeitzone: string = "";
let reiseBeginn: boolean = true;
let zwischenTag: boolean = false;
let onlyRK = ref<boolean>(false);
let onlyBDE = ref<boolean>(false);
const siteData = getSiteData();
let editaic = ref<number>(0);
let timeInvalid = ref<boolean>(false);
let varUbergabe = ref<VarUebergabe[]>([]);
let setKey = ref<number>(0);

const vueInstance = getCurrentInstance();

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "WebLetzteStempelung",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

onMounted(async () => {
  if (siteData && siteData.aic) {
    pageParams.aic = siteData.aic;
    editaic.value = siteData.aic;
  }
  // am Handy sollen die Buttons angezeigt werden!
  if (Constants.isMobile) {
    showCarousel.value = false;
  }
  if (!checkBegriff("SoftTerm_Stempelungen")) {
    onlyRK.value = true;
  }
  if (checkBegriff("Web_ReiseUebersichtBuchungen")) {
    pageParams.query = "Web_ReiseUebersichtBuchungen";
  }
  await reloadReisen();
  // await mountedBase(uiData, pageParams, false);
  if (checkBegriff("PZE_Web_Zeitzone_Nacherfassen")) {
    showZeitzone.value = true;
    offset = new Date().getTimezoneOffset() * -1;
    const localQuery = "Web_Erfassung_Zeitzone";
    AUApi.Current.getQuery(
      // Query
      localQuery,
      // Done function
      (data: any) => dataLoadedZone(data),
      0,
      pageParams.zeitbereich,
      0,
      false,
      false,
      "",
      0,
      [],
    );
  }
});
async function reloadReisen() {
  carousel1 = [];
  carousel2 = [];
  carousel3 = [];
  if (pageParams.query) {
    if (siteData) {
      timeInvalid.value = true;
      if (siteData.zeitbereich) {
        abwUhrzeit = siteData.zeitbereich.von;
        dateString.value = siteData.zeitbereich.von.toLocaleDateString();
        // Zeitzone GMT - sonst rechnet er bei Amerika zB einen Tag weg!
        timeDate = siteData.zeitbereich.von.toISOStringWithTZGMT();
      } else {
        // sollte der markierte Tag aus der Time Line sein??
        abwUhrzeit.value = AUApi.Current.zeitbereich.von;
        dateString.value = siteData.zeitbereich.von.toLocaleDateString();
      }
    }
    await mountedBase(uiData, pageParams, false);
    if (!uiData.showLoading && uiData.data) {
      reiseBeginn = false;
      if (uiData.data.length > 0 && uiData.data[0].aic_Stamm) {
        const endeReise = getKennungValue(
          uiData.data[0],
          "RK_REISE_BEENDET",
          uiData.columns,
        );
        const beginnReise = getKennungValue(
          uiData.data[0],
          "BEGIN",
          uiData.columns,
        );
        const abfahrt = getKZValue(uiData.data[0], "Abfahrt", uiData.columns);
        const ankunftOri = getKZValue(
          uiData.data[0],
          "Ankunft",
          uiData.columns,
        );
        let ankunft = getKZValue(uiData.data[0], "Ankunft", uiData.columns);
        if (ankunft) {
          ankunft = new Date(ankunft).toISOStringWithTZ().substr(0, 10);
          ankunft = new Date(ankunft).toISOStringWithTZGMT();
        }
        // nur wenn die reise noch nicht beendet ist - sperren!"
        const beginnDate = new Date(beginnReise);
        const endeDate = new Date(endeReise);
        const von = siteData?.zeitbereich.von;
        const bis = siteData?.zeitbereich.bis;
        const bisZZ = siteData?.zeitbereich.bis.toISOStringWithTZGMT();
        if (!endeReise) {
          reiseBeginn = true;
        } else if (
          beginnDate.valueOf() !== von.valueOf() &&
          endeDate.valueOf() !== bis.valueOf()
        ) {
          // an Tagen zwischen Beginn und Ende darf kein neuer Beginn eingetragen werden
          reiseBeginn = true;
          zwischenTag = true;
        }
        // gibt es schon mehrere Reisezeiten Buchungen
        // auch in der Zukunft dann darf ich nicht mehr davor BEENDEN!
        if (
          ankunft &&
          abfahrt !== ankunftOri &&
          ankunft.valueOf() !== bisZZ.valueOf() &&
          ankunft.valueOf() >= bisZZ.valueOf()
        ) {
          zwischenTag = true;
        }
      }
      if (siteData?.nurBDE) {
        onlyBDE.value = true;
      }
    }
    await initialize();
    setKey.value += +1;
    uiData.showLoading = false;
    uiData.initialized = true;
  }
}
function dataLoadedZone(data: any) {
  if (data.data.error !== undefined) {
    AUApi.Current.onfail(data.data.error);
    console.log(data.data.error);
    alert("ACHTUNG: " + data.data.error);
    emit("back");
    return;
  }
  const columns = data.data.columns;
  const dataZone = data.data.data;
  if (dataZone?.length > 0) {
    for (let i = 0; i < dataZone.length; i++) {
      const row = dataZone[i];
      const title = getKennungValueDisplay(row, "BEZEICHNUNG", columns);
      const aic = getKennungValueDisplay(row, "SYSAIC", columns);
      const differenz = getKennungValue(row, "ZONE_MIN", columns);
      let select = false;
      // muss mit der Winterzeit vergleichen - weil sonst hab ich es im Sommer um 1 h falsch"!
      const wzOffset = new Date("1970-01-01").getTimezoneOffset() * -1;
      if (wzOffset === differenz) {
        select = true;
      }
      const subtitel = getKennungValueDisplay(row, "KURZBEZEICHNUNG", columns);
      zeitzones.value.push({
        title,
        subtitel,
        aic,
        select,
        differenz,
      });
    }
  } else {
    showZeitzone.value = false;
  }
}
function selectChange(val: any) {
  const select = val.select;
  aktZeitzone = val.aic;
  offsetChange = false;
  if (offset !== val.differenz) {
    offsetChange = true;
    // offset = lokale zeitzone, zb -60
    changedoffset = val.differenz;
    // differnz ist zb -120 - die neue Zeitzone
    // offsetString = MET / UTC... etc die kürzel für die Zeitzone
    offsetString = val.subtitel;
    if (abwUhrzeit.value) {
      uhrzeit = new Date(abwUhrzeit.value).toISOStringWithDifferentTimeZone(
        changedoffset,
      );
    }
  } else {
    uhrzeit = "";
  }
  const tempZone: any = zeitzones;
  for (let i = 0; i < tempZone.length; i++) {
    if (aktZeitzone !== tempZone[i].aic) {
      tempZone[i].select = false;
    }
  }
  zeitzones = tempZone;
}
async function initialize() {
  if (checkBegriff("Kommt_Geht_Nacherfassung") && !onlyBDE.value) {
    carousel1.push({
      modell: "PZE_Web_StempelungenSpeichern",
      color: "success",
      icon: "mdi-home-city",
      text: globalsBezeichnung(Globals.Begriff, "Web_KommtGeht", "Kommt/Geht"),
    });
  }
  if (
    checkBegriff("Homeoffice_Nacherfassung") && // es müssen BEIDE texte da sein - sonst nicht anzeigen!
    checkBegriff("Web_HO_Einzelzeitart_Nacherfassung") &&
    !onlyBDE.value
  ) {
    carousel1.push({
      modell: "PZE_Web_Homeoffice_Speichern",
      color: "#1f3e52",
      icon: "mdi-home-account",
      text: globalsBezeichnung(
        Globals.Begriff,
        "PZE_Web_Homeoffice_Speichern",
        "Homeoffice",
      ),
    });
  }
  if (checkBegriff("Kundenbesuch_Nacherfassung") && !onlyBDE.value) {
    carousel1.push({
      modell: "PZE_Web_KG_Kundenbesuch",
      color: "dvhMenu2",
      icon: "mdi-card-account-mail",
      text: globalsBezeichnung(
        Globals.Begriff,
        "PZE_Web_KG_Kundenbesuch",
        "Kundenbesuch",
      ),
    });
  }
  // carousel 2
  if (!onlyRK.value && !onlyBDE.value) {
    if (checkBegriff("Web_RK_DR_Beginn") && !reiseBeginn) {
      carousel2.push({
        site: "SoftTermReisenDienstReiseBeginn",
        color: globalsModellFarbe(
          Globals.Begriff,
          "PZE_Web_Ereignis_DG_ausserHaus",
          "#1f3e52",
        ),
        icon: "mdi-briefcase-outline",
        text: globalsBezeichnung(
          Globals.Begriff,
          "Web_RK_DR_Beginn",
          "Dienstreise Beginn",
        ),
        // + Parameter FALSE - ENDE = False
      });
    }
    if (checkBegriff("Web_RK_DR_Ende") && reiseBeginn && !zwischenTag) {
      carousel2.push({
        color: globalsModellFarbe(
          Globals.Begriff,
          "PZE_Web_Ereignis_DG_ausserHaus",
          "#1f3e52",
        ),
        icon: "mdi-briefcase-outline",
        text: globalsBezeichnung(
          Globals.Begriff,
          "Web_RK_DR_Ende",
          "Dienstreise Ende",
        ),
        site: "SoftTermReisenDienstReiseEnde",
      });
    }
    if (checkBegriff("Web_RK_Grenzuebertritt") && reiseBeginn) {
      carousel2.push({
        color: "green",
        icon: "mdi-briefcase-outline",
        text: globalsBezeichnung(
          Globals.Begriff,
          "Web_RK_Grenzuebertritt",
          "Grenzübertritt",
        ),
        query: "WEB_RK_Ortswechsel_RZ",
        site: "SoftTermReisenGrenzuebertritt",
      });
    }
    if (checkBegriff("Web_RK_Ortswechsel") && reiseBeginn) {
      carousel2.push({
        color: "green",
        icon: "mdi-briefcase-outline",
        text: globalsBezeichnung(
          Globals.Begriff,
          "Web_RK_Ortswechsel",
          "Zwischenstopp",
        ),
        site: "SoftTermReisenGrenzuebertritt",
        query: "Web_RK_Zwischenstop",
      });
    }
    if (checkBegriff("Web_RK_Fahrzeugwechsel") && reiseBeginn) {
      carousel2.push({
        color: "green",
        icon: "mdi-car",
        text: globalsBezeichnung(
          Globals.Begriff,
          "Web_RK_Fahrzeugwechsel",
          "Fahrzeugwechsel",
        ),
        query: "WEB_RK_Ortswechsel_RZ",
        site: "SoftTermReisenGrenzuebertritt",
        fahrzeug: true,
      });
    }
    if (checkBegriff("EndeDienstreiseNacherfassung")) {
      carousel2.push({
        color: "red",
        icon: "mdi-home-off-outline",
        text: globalsBezeichnung(
          Globals.Begriff,
          "PZE_Web_Ende_DR",
          "Ende Dienstreise",
        ),
        modell: "PZE_Web_Ende_DR",
      });
    }

    if (checkBegriff("EndeAusserHaus_Nacherfassung")) {
      carousel2.push({
        color: "warning",
        icon: "mdi-location-exit",
        text: globalsBezeichnung(
          Globals.Begriff,
          "PZE_Web_EndeAusserHaus_stempeln",
          "Ende ausser Haus",
        ),
        modell: "PZE_Web_EndeAusserHaus_stempeln",
      });
    }
  }
  // carousel 3
  if (onlyRK.value) {
    // carousel 3
    if (checkBegriff("Web_RK_DR_Beginn") && !reiseBeginn) {
      carousel3.push({
        color: globalsModellFarbe(
          Globals.Begriff,
          "PZE_Web_Ereignis_DG_ausserHaus",
          "#1f3e52",
        ),
        icon: "mdi-briefcase-outline",
        text: globalsBezeichnung(
          Globals.Begriff,
          "Web_RK_DR_Beginn",
          "Dienstreise Beginn",
        ),
        site: "SoftTermReisenDienstReiseBeginn",
      });
    }
    if (checkBegriff("Web_RK_DR_Ende") && reiseBeginn && !zwischenTag) {
      carousel3.push({
        color: globalsModellFarbe(
          Globals.Begriff,
          "PZE_Web_Ereignis_DG_ausserHaus",
          "#1f3e52",
        ),
        icon: "mdi-briefcase-outline",
        text: globalsBezeichnung(
          Globals.Begriff,
          "Web_RK_DR_Ende",
          "Dienstreise Ende",
        ),
        site: "SoftTermReisenDienstReiseEnde",
      });
    }
    if (
      checkBegriff("Web_RK_Grenzuebertritt") &&
      (reiseBeginn || zwischenTag)
    ) {
      carousel3.push({
        color: "green",
        icon: "mdi-briefcase-outline",
        text: globalsBezeichnung(
          Globals.Begriff,
          "Web_RK_Grenzuebertritt",
          "Grenzübertritt",
        ),
        site: "SoftTermReisenGrenzuebertritt",
        query: "WEB_RK_Ortswechsel_RZ",
      });
    }
    if (
      checkBegriff("Web_RK_Ortswechsel") &&
      (reiseBeginn || zwischenTag) &&
      !checkBegriff("Web_RK_Fahrzeugwechsel")
    ) {
      carousel3.push({
        color: "green",
        icon: "mdi-briefcase-outline",
        text: globalsBezeichnung(
          Globals.Begriff,
          "Web_RK_Ortswechsel",
          "Zwischenstopp",
        ),
        site: "SoftTermReisenGrenzuebertritt",
        query: "Web_RK_Zwischenstop",
      });
    }
    if (
      checkBegriff("Web_RK_Ortswechsel") &&
      (reiseBeginn || zwischenTag) &&
      checkBegriff("Web_RK_Fahrzeugwechsel")
    ) {
      carousel3.push({
        color: "green",
        icon: "mdi-car",
        text: globalsBezeichnung(
          Globals.Begriff,
          "Web_RK_Fahrzeugwechsel",
          "Fahrzeugwechsel",
        ),
        query: "Web_RK_Zwischenstop",
        site: "SoftTermReisenGrenzuebertritt",
      });
    }

    if (
      (checkBegriff("EndeAusserHaus_Nacherfassung") && !onlyRK) ||
      (onlyRK && reiseBeginn && checkBegriff("EndeAusserHaus_Nacherfassung"))
    ) {
      carousel3.push({
        color: "warning",
        icon: "mdi-location-exit",
        text: globalsBezeichnung(
          Globals.Begriff,
          "PZE_Web_EndeAusserHaus_stempeln",
          "Ende ausser Haus",
        ),
        modell: "PZE_Web_EndeAusserHaus_stempeln",
      });
    }
    if (checkBegriff("EndeDienstreiseNacherfassung")) {
      carousel3.push({
        color: "red",
        icon: "mdi-home-off-outline",
        text: globalsBezeichnung(
          Globals.Begriff,
          "PZE_Web_Ende_DR",
          "Ende Dienstreise",
        ),
        modell: "PZE_Web_Ende_DR",
      });
    }
  }
}
async function clearAndFocus() {
  abwUhrzeit.value = null;
  timeInvalid.value = true;
  await reloadReisen();
}

async function timeChanged(d: any) {
  try {
    if (!d) {
      console.log("time changed: null");
      abwUhrzeit.value = null;
      return;
    } else {
      if (typeof d === "string") {
        abwUhrzeit.value = new Date(d);
        // wurde bereits die Zeitzone geändert, dann muss auch bei der nächsten Buchung die Zone gepüft werden
        if (offsetChange) {
          uhrzeit = new Date(abwUhrzeit.value).toISOStringWithDifferentTimeZone(
            changedoffset,
          );
        }
        await setVariablen();
        timeInvalid.value = false;
        return;
      }

      const time = d.value as Date;
      console.log("time changed: " + time.toISOStringWithTZ());
      abwUhrzeit.value = time;
    }
  } finally {
    // $forceUpdate();
  }
}

function onCalculating(args: any) {
  // sicherheitshalber erst im nächsten tick ausleeren damit ma nicht gleich ein update im button auslösen..
  nextTick(() => {
    memo.value = "";
    abwUhrzeit.value = null;
    uhrzeit = "";
  });
}
function onCalculated(args: any) {
  response = JSON.stringify(args);
  letzteBuchung = args.text;
  letzteBuchung = letzteBuchung.slice(0, 10);
  letzteBuchungUm = args.ergebnis;
  if (letzteBuchungUm === "" || letzteBuchungUm === undefined) {
    letzteBuchung = "";
  }
  if (letzteBuchungUm) {
    buchungsText.value =
      begriffBezeichnung("Web_letzteBuchung") + " " + letzteBuchungUm;
  }
  if (letzteBuchung) {
    buchungsText.value = buchungsText.value + " - " + letzteBuchung;
  }
  // auch aus dem SAVE können JSON Paramater übertragen werden - dann muss ich die hier auch weiter übergeben!
  if (args.JSON?.Gueltigkeit && siteData) {
    siteData.abwZeitraum = args.JSON.Gueltigkeit;
  }
  if (args.JSON?.fullReload && siteData) {
    siteData.fullReload = args.JSON.fullReload;
  }
  if (args.ergebnis) {
    letzteBuchung = "";
  }
  memo.value = "";
  abwUhrzeit.value = null;
  uhrzeit = "";
  clearAndFocus();
}

function initTimeValue() {
  if (abwUhrzeit.value) {
    return abwUhrzeit.value.toISOStringWithTZ();
  }
  return null;
}

// während des Folienwechsels Carousels sperren, sonst trifft ein 2. Klick den Button der nächsten Folie
const { locked: slideLocked, guard: slideGuard } = useClickLock();
const cycleSlides = slideGuard(() => {
  currentSlide.value = (currentSlide.value + 1) % carousel1.length;
});
const cycleSlides2 = slideGuard(() => {
  currentSlide2.value = (currentSlide2.value + 1) % carousel2.length;
});
const cycleSlides3 = slideGuard(() => {
  currentSlide3.value = (currentSlide3.value + 1) % carousel3.length;
});
const openFrame = singleClick(openFrameImpl);
async function openFrameImpl(
  site: string,
  item?: carouselItems,
  text?: string,
) {
  await setVariablen();

  let keinBDEAntrag = true;
  const data = {
    zeitbereich: siteData?.zeitbereich ?? AUApi.Current.zeitbereich,
    varUbergabe: varUbergabe.value,
  };
  let name = site;
  if (item?.site) {
    name = item?.site;
  }
  let fahrzeug = false;
  if (item && item.fahrzeug) {
    fahrzeug = item.fahrzeug;
    varUbergabe.value.push({
      var: "Fahrzeugwechsel",
      type: "boolean",
      wert: true,
      art: 1,
      user: AUApi.Current.user.user,
      perm: false,
    });
  }
  let title = "";
  if (item && item.text) {
    title = item.text;
  } else {
    title = globalsBezeichnung(Globals.Begriff, text ?? name, "Erfassung");
  }
  let fullscreen = false;
  if (Constants.isMobile) {
    fullscreen = true;
  }
  showDialog({
    data: {
      zeitbereich: siteData?.zeitbereich ?? AUApi.Current.zeitbereich,
      keinBDEAntrag,
      aic: editaic.value, // muss unbedingt value sein, sonst wird es durch die Submasken üebrschrieben!
      varUbergabe: varUbergabe.value,
      query: item?.query,
      fahrzeug: item?.fahrzeug ?? false,
    },
    title,
    width: 600,
    fullscreen,
    height: 400,
    site: name,
    okButton: false,

    onClose: (dlg: DialogParameter) => {
      const x = dlg?.returnedData;
      if (x) {
        if (x.JSON?.fullReload && siteData) {
          siteData.fullReload = x.JSON.fullReload;
        }
        if (x.JSON?.Gueltigkeit && siteData) {
          siteData.abwZeitraum = x.JSON.Gueltigkeit;
        }
        letzteBuchungUm = "";
        letzteBuchung = x.ergebnis;
        buchungsText.value =
          begriffBezeichnung("Web_letzteBuchung") + " " + letzteBuchung;
      }
      clearAndFocus();
      return true;
    },
  });
}
async function setVariablen() {
  const variablen: VarUebergabe[] = [];
  // varUbergabe.value = [];
  if (memo.value) {
    variablen.push({
      var: "WebMemo",
      type: "string",
      wert: memo.value,
      art: 1,
      user: AUApi.Current.user.user, // wirklich die user ID
      perm: false,
    });
  }
  if (!aktZeitzone) {
    const lokalOffset = new Date().getTimezoneOffset() * -1;
    const serverTime = AUApi.Current.user.time;
    const serverOffset = Date.getISOTimeZoneOffsetInMin(serverTime);

    if (lokalOffset !== serverOffset) {
      const newtimeZone = new Date("2021-01-01").getTimezoneOffset() * -1;
      variablen.push({
        var: "differentTimeZone",
        type: "boolean",
        wert: true,
        art: 1,
        user: AUApi.Current.user.user, // wirklich die user ID
        perm: false,
      });
      variablen.push({
        var: "newtimeZone",
        type: "int",
        wert: newtimeZone,
        art: 1,
        user: AUApi.Current.user.user,
        perm: false,
      });
    }
  } else {
    variablen.push({
      var: "Zeitzone",
      type: "int",
      wert: aktZeitzone,
      art: 1,
      user: AUApi.Current.user.user, // wirklich die user ID
      perm: false,
    });
  }
  if (abwUhrzeit.value) {
    const wert = new Date(abwUhrzeit.value).toISOStringWithTZ();
    variablen.push({
      var: "WebabwUhrzeit",
      type: "string",
      wert,
      art: 1,
      user: AUApi.Current.user!.user,
      perm: false,
    });
  }
  console.log(variablen);

  varUbergabe.value = variablen;
}
interface NavData {
  query: string;
  showClose: boolean;
  onReloadData: boolean;
}
declare interface carouselItems {
  color?: string;
  icon?: string;
  text?: string;
  modell?: string;
  variable?: string;
  varName?: string;
  variable1?: Date | null;
  varDatum?: string;
  checkTimeZone?: boolean;
  checkGeoLocation?: boolean;
  edit?: string;
  query?: string;
  modellDefault?: string;
  site?: string;
  fahrzeug?: boolean;
}
</script>
<template>
  <div
    max-width="400px"
    min-height="600px"
    class="d-flex flex-wrap ga-1"
    v-if="uiData.initialized"
    :key="setKey"
  >
    <v-row min-height="60px">
      <v-col cols="5" class="pl-8 my-2">
        <h3 class="pt-2">{{ dateString }}</h3>
      </v-col>
      <v-col cols="5" class="mt-2">
        <EditTimePicker
          v-model="abwUhrzeit"
          ref="timePicker"
          :isRequired="true"
          @changeValue="timeChanged"
          :showField="true"
          formatProp="HH:mm"
          :disabled="false"
          :initValue="initTimeValue"
          :timeDate="timeDate"
          title="HH:mm"
          :disableValueChangeTracker="true"
          :autofocus="true"
        ></EditTimePicker>
      </v-col>
      <v-col cols="2" class="mt-2" v-if="abwUhrzeit && showZeitzone">
        <v-menu :close-on-click="false">
          <template v-slot:activator="{ props }">
            <v-btn variant="text" icon="mdi-map-clock-outline" v-bind="props">
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(zeitzone, index) in zeitzones"
              :key="index"
              :class="[{ 'blue lighten-5': zeitzone.select }, 'white']"
              density="compact"
            >
              <template v-slot:prepend>
                <v-checkbox
                  @update:modelValue="selectChange(zeitzone)"
                  v-model="zeitzone.select"
                  hide-details
                ></v-checkbox
              ></template>
              <v-list-item-title>
                {{ zeitzone.title }} ({{ zeitzone.subtitel }} )
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <v-carousel
      progress="#db5959"
      width="auto"
      height="60"
      :show-arrows="false"
      hide-delimiters
      hide-delimiter-background
      v-model="currentSlide"
      :style="slideLocked ? 'pointer-events: none' : ''"
      v-if="uiData.initialized && carousel1.length > 0"
    >
      <v-carousel-item v-for="(car, i) in carousel1" :key="i + 'xy'">
        <CalcButton
          class="fill-height"
          :text="car.text"
          :modell="car.modell"
          :color="car.color"
          :icon="car.icon"
          @calculating="onCalculating"
          :varUebergabe="varUbergabe"
          @calculated="onCalculated"
          :disabled="timeInvalid"
          :modellAic="editaic"
        ></CalcButton>
        <div cols="2" class="navigation-arrows" v-if="carousel1.length > 1">
          <v-btn
            size="small"
            icon="mdi-chevron-right"
            color="error"
            class="my-1"
            @click="cycleSlides"
          >
          </v-btn>
        </div>
      </v-carousel-item>
    </v-carousel>
    <v-button-carousel
      v-if="
        uiData.initialized &&
        !checkBegriff('Web_HO_Einzelzeitart_Nacherfassung') &&
        checkBegriff('Web_HO_SoftTerminal') &&
        !onlyBDE
      "
      icon="mdi-home-account"
      :varUebergabe="varUbergabe"
      query="Web_HO_SoftTerminal"
      modellDefault="PZE_Web_HO_Menge_buchen"
      @calculating="onCalculating"
      @calculated="onCalculated"
      :disabled="timeInvalid"
      :checkTimeZone="true"
      :modellAic="editaic"
    ></v-button-carousel>
    <v-button-carousel
      v-if="
        uiData.initialized &&
        checkBegriff('Web_Zeitart_Nacherfassung') &&
        !onlyBDE
      "
      icon="mdi-exit-to-app"
      query="Web_Zeitarten_Nacherfassung_unproduktiv"
      modellDefault="PZE_Web_Zeitarten_buchen"
      @calculating="onCalculating"
      @calculated="onCalculated"
      :disabled="timeInvalid"
      :checkTimeZone="true"
      :modellAic="editaic"
      :varUebergabe="varUbergabe"
    ></v-button-carousel>
    <v-button-carousel
      v-if="
        uiData.initialized &&
        checkBegriff('Web_Zeitart_Nacherfassung') &&
        !onlyBDE
      "
      icon="mdi-calendar-outline"
      query="Web_Zeitarten_Nacherfassung_produktiv"
      modellDefault="PZE_Web_Zeitarten_buchen"
      @calculating="onCalculating"
      @calculated="onCalculated"
      :disabled="timeInvalid"
      :checkTimeZone="true"
      :modellAic="editaic"
      :varUebergabe="varUbergabe"
    ></v-button-carousel>
    <!-- carousel2-->
    <v-button-carousel
      v-if="
        checkBegriff('Web_Zeitart_FortsetzungDR') &&
        checkBegriff('PZE_Web_SoftwareTerminal') &&
        reiseBeginn
      "
      icon="mdi-home-account"
      varDatum="WebabwUhrzeit"
      query="Web_Zeitart_FortsetzungDR"
      modellDefault="PZE_Web_Zeitarten_buchen"
      @calculating="onCalculating"
      @calculated="onCalculated"
      :disabled="timeInvalid"
      :checkTimeZone="true"
      :modellAic="editaic"
      :varUebergabe="varUbergabe"
    ></v-button-carousel>
    <v-carousel
      progress="#db5959"
      width="auto"
      height="60"
      :show-arrows="false"
      hide-delimiters
      hide-delimiter-background
      v-model="currentSlide2"
      :style="slideLocked ? 'pointer-events: none' : ''"
      v-if="uiData.initialized && carousel2.length > 0"
    >
      <!-- <v-button-carousel
        v-if="
          checkBegriff('Web_Zeitart_FortsetzungDR') &&
          checkBegriff('PZE_Web_SoftwareTerminal') &&
          reiseBeginn
        "
        icon="mdi-home-account"
        varDatum="WebabwUhrzeit"
        query="Web_Zeitart_FortsetzungDR"
        modellDefault="PZE_Web_Zeitarten_buchen"
        @calculated="onCalculated"
        :disabled="timeInvalid"
        :checkTimeZone="true"
        :modellAic="editaic"
        :varUebergabe="varUbergabe"
      ></v-button-carousel> -->
      <v-carousel-item v-for="(car2, i) in carousel2" :key="i">
        <CalcButton
          v-if="car2.modell"
          class="fill-height"
          :text="car2.text"
          :modell="car2.modell"
          :color="car2.color"
          :icon="car2.icon"
          @calculating="onCalculating"
          @calculated="onCalculated"
          :varUebergabe="varUbergabe"
          :disabled="timeInvalid"
          :modellAic="editaic"
        ></CalcButton>
        <v-btn
          v-if="car2.site"
          block
          variant="flat"
          class="calcButton"
          :color="car2.color"
          id="DREnde"
          @click="openFrame('', car2)"
          :prepend-icon="car2.icon"
          :text="car2.text"
          :disabled="timeInvalid"
          rounded="0"
        >
        </v-btn>
        <div class="navigation-arrows" v-if="carousel2.length > 1">
          <v-btn
            size="small"
            icon="mdi-chevron-right"
            color="error"
            class="my-1"
            @click="cycleSlides2"
          >
          </v-btn>
        </div>
      </v-carousel-item>
    </v-carousel>

    <v-carousel
      progress="#db5959"
      width="auto"
      height="60"
      :show-arrows="false"
      hide-delimiters
      hide-delimiter-background
      v-model="currentSlide3"
      :style="slideLocked ? 'pointer-events: none' : ''"
      v-if="uiData.initialized && carousel3.length > 0"
    >
      <v-button-carousel
        v-if="
          checkBegriff('Web_Zeitart_FortsetzungDR') &&
          checkBegriff('PZE_Web_SoftwareTerminal') &&
          reiseBeginn
        "
        icon="mdi-home-account"
        varDatum="WebabwUhrzeit"
        query="Web_Zeitart_FortsetzungDR"
        modellDefault="PZE_Web_Zeitarten_buchen"
        :varUebergabe="varUbergabe"
        @calculating="onCalculating"
        @calculated="onCalculated"
      ></v-button-carousel>
      <v-carousel-item v-for="(car3, i) in carousel3" :key="i">
        <CalcButton
          v-if="car3.modell"
          class="fill-height"
          :text="car3.text"
          :modell="car3.modell"
          :color="car3.color"
          :icon="car3.icon"
          @calculating="onCalculating"
          @calculated="onCalculated"
          :varUebergabe="varUbergabe"
          :disabled="timeInvalid"
          :modellAic="editaic"
        ></CalcButton>
        <v-btn
          v-if="car3.site"
          variant="flat"
          block
          class="calcButton"
          :color="car3.color"
          id="DREnde"
          @click="openFrame('', car3)"
          :prepend-icon="car3.icon"
          :text="car3.text"
          rounded="0"
        >
        </v-btn>
        <div class="navigation-arrows" v-if="carousel3.length > 1">
          <v-btn
            size="small"
            icon="mdi-chevron-right"
            color="error"
            class="my-1"
            @click="cycleSlides3"
          >
          </v-btn>
        </div>
      </v-carousel-item>
    </v-carousel>

    <v-carousel
      progress="#db5959"
      width="auto"
      height="60"
      :show-arrows="false"
      hide-delimiters
      hide-delimiter-background
      v-if="
        uiData.initialized &&
        checkBegriff('EndeDRVereinfachtNacherfassung') &&
        !onlyBDE
      "
    >
      <v-carousel-item>
        <CalcButton
          :text="
            globalsBezeichnung(
              Globals.Begriff,
              'PZE_Web_DR_Ende',
              'Ende Dienstreise',
            )
          "
          modell="PZE_Web_DR_Ende"
          color="blue"
          icon="mdi-airplane-off"
          @calculating="onCalculating"
          @calculated="onCalculated"
          :disabled="timeInvalid"
          :checkTimeZone="true"
          :modellAic="editaic"
          :varUebergabe="varUbergabe"
        />
      </v-carousel-item>
    </v-carousel>
    <v-btn
      v-if="uiData.initialized && checkBegriff('BDEErfassun_Nacherfassung')"
      block
      variant="flat"
      class="calcButton"
      color="secondary"
      id="bde"
      @click="openFrame('SoftTermBDE', {}, 'Web_BDE_Erfassung')"
      :disabled="timeInvalid"
      @calculating="onCalculating"
      @calculated="onCalculated"
      prepend-icon="mdi-puzzle-outline"
      :text="globalsBezeichnung(Globals.Begriff, 'SoftTerm_BDE', 'BDE')"
      rounded="0"
    >
    </v-btn>
    <v-textarea
      clearable
      clear-icon="mdi-close-circle"
      :label="globalsBezeichnung(Globals.Begriff, 'Memo', 'Notiz')"
      :name="globalsBezeichnung(Globals.Begriff, 'Memo', 'Notiz')"
      variant="outlined"
      bgColor="white"
      hide-details
      rows="2"
      row-height="15"
      v-model="memo"
      :hint="globalsBezeichnung(Globals.Begriff, 'Memo', 'Notiz')"
      @update:modelValue="setVariablen"
    ></v-textarea>
    <v-container class="pa-0 d-flex align-center">
      <v-banner v-if="buchungsText" lines="three" class="pb-5">
        <v-banner-text>
          {{ buchungsText }}
        </v-banner-text>
      </v-banner>
    </v-container>
  </div>
</template>

<style scoped>
.v-banner {
  background: white;
  color: green;
}
.navigation-arrows {
  position: absolute;
  top: 0;
  right: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
}
.calcButton {
  text-align: left;
  white-space: normal;
  padding: 5px;
  /* margin-top: 5px; */
  height: 60px;
  justify-content: left;
}
.fullcol {
  width: 100%;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 0px;
  padding-right: 0px;
  margin-bottom: 2px;
}
.calcButton[disabled],
.calcButton.v-btn--disabled,
.calcButton:disabled,
.v-btn.calcButton[disabled] {
  background-color: rgb(
    102,
    101,
    101
  ) !important; /* hellgrau (anpassen falls CalcButton andere Graunuance hat) */
  color: #ffffff !important; /* weiße Schrift */
}
</style>
